// import { useState } from "react";
// import { GoChevronLeft, GoChevronRight } from "react-icons/go";

import {
  Flex,
  Image,
  Stack,
  Button,
  Heading,
  Collapse,
  useBoolean,
  useBreakpointValue,
} from "@chakra-ui/react";

// import { CustomIconButton } from "../components/CustomIconButton";

import { testimonials } from "../helpers";

import vhs from "../media/vhs.jpg";
import reflection from "../media/reflection.jpg";

export const Testimonials = () => {
  const collapseHeight = useBreakpointValue({ base: 200, md: 290 });
  const image = useBreakpointValue({ base: vhs, md: reflection });

  const [showTestimonial, setShowTestimonial] = useBoolean();
  // const [testimonialIndex, setTestimonialIndex] = useState(0);

  // const maxTestimonialIndex = testimonials.length - 1;

  // const onPrevTestimonial = () => {
  // 	if (testimonialIndex !== 0) {
  // 		setTestimonialIndex((prevTestimonialIndex) => prevTestimonialIndex - 1);
  // 	} else {
  // 		setTestimonialIndex(maxTestimonialIndex);
  // 	}
  // };

  // const onNextTestimonial = () => {
  // 	if (testimonialIndex < maxTestimonialIndex) {
  // 		setTestimonialIndex((prevTestimonialIndex) => prevTestimonialIndex + 1);
  // 	} else {
  // 		setTestimonialIndex(0);
  // 	}
  // };

  return (
    <Flex
      h="auto"
      id="testimonials"
      pt={{ base: "4", md: "8" }}
      gap={{ base: "4", md: "8" }}
      direction={{ base: "column", md: "row" }}
    >
      <Image
        h="auto"
        src={image}
        objectFit="cover"
        rounded={{ md: "3" }}
        transition="width 1s"
        w={{ base: "100%", md: showTestimonial ? "0%" : "50%" }}
      />

      <Stack justify="space-between" gap="4" px={{ base: "4", md: "0" }}>
        <Collapse startingHeight={collapseHeight} in={showTestimonial}>
          <Stack gap="0">
            <Heading>❞</Heading>
            <Stack gap="4">
              {testimonials[0].testimonial.map((paragraph) => (
                <Heading fontSize="3xl" key={paragraph}>
                  {paragraph.toUpperCase()}
                </Heading>
              ))}
            </Stack>
            <Heading textAlign="right">❞</Heading>
          </Stack>
        </Collapse>

        <Flex gap="4">
          {/* <Flex gap="2">
            <CustomIconButton
              icon={<GoChevronLeft />}
              onClick={onPrevTestimonial}
            />
            <CustomIconButton
              icon={<GoChevronRight />}
              onClick={onNextTestimonial}
            />
          </Flex> */}

          <Button
            pr="3.5"
            size="sm"
            rounded="3"
            fontSize="md"
            w="fit-content"
            bg="brand.dark"
            color="brand.light"
            fontFamily="Kalnia Variable"
            _hover={{ bg: "brand.contrast" }}
            onClick={setShowTestimonial.toggle}
          >
            {showTestimonial ? "HIDE TESTIMONIAL" : "READ TESTIMONIAL"}
          </Button>
        </Flex>
      </Stack>
    </Flex>
  );
};
